export default "__VITE_ASSET__DJfRifoB__"